<script lang="ts">
    import { CustomIcon, getIcon } from '@components/icons';
    import { storyFeedStore } from '@components/story/feed';
    import { LL } from '@i18n/i18n-svelte';
    import { Font, FontTypes } from '@uikit/font';
    import { SvgIcon } from '@uikit/svg-icon';

    import s from './swipe-info.module.css';

    let hideSwipeInfo: boolean;
    $: hideSwipeInfo = $storyFeedStore.hideSwipeInfo;

    const closeSwipeInfo = () => {
        storyFeedStore.setHideSwipeInfo(true);
    };
</script>

{#if !hideSwipeInfo}
    <button class={s.root} on:pointerdown={closeSwipeInfo}>
        <div class={s.swipeInfoContainer}>
            <SvgIcon classes={s.swipeUpIcon} icon={getIcon(CustomIcon.swipeUp)} />
            <Font
                className={s.swipeInfo}
                type={FontTypes.Type.h3}
                tagName={FontTypes.TagName.h3}
                isBold
            >
                {$LL.story.swipeInfo()}
            </Font>
        </div>
    </button>
{/if}
